import { render, staticRenderFns } from "./ SubmittingScores.vue?vue&type=template&id=1d45a062"
import script from "./ SubmittingScores.vue?vue&type=script&lang=js"
export * from "./ SubmittingScores.vue?vue&type=script&lang=js"
import style0 from "./ SubmittingScores.vue?vue&type=style&index=0&id=1d45a062&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports